<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <step-counter paso="4" />
      <wrap-container class="cascade w50">
        <wrap-container>
          <p
            id="antetitulo"
            class="titulo antetitulo p28 light oscuro"
            v-if="config.pasos.identidad.antetitulo"
            v-safe-html="config.pasos.identidad.antetitulo"
          />
          <p
            id="titulo"
            class="titulo medium oscuro"
            v-safe-html="config.pasos.identidad.titulo"
          />
          <p
            id="subtitulo"
            class="titulo oscuro"
            v-safe-html="config.pasos.identidad.subtitulo"
          />
        </wrap-container>
        <wrap-container>
          <validation-element
            class="iniciar-validacion-digital"
            @comenzar-validacion="initValidacion"
          />
        </wrap-container>
        <button class="anterior-link" type="button" @click="atras">
          Anterior
        </button>
      </wrap-container>
      <wrap-container class="cascade w50"></wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import StepCounter from "@/components/core/StepCounter";
import ValidationElement from "@/components/core/ValidationElement";
import { ERROR_HABILITA_PERMISOS } from "@/config/constants/step-constants";
import Vue from "vue";

export default {
  name: "identidad",
  components: {
    WrapContainer,
    ValidationElement,
    StepCounter
  },
  data() {
    return {
      model: this.$store.getters.getIdentidad()
    };
  },
  mounted() {
    this.$store.commit("ON_RESULT_VERIDAS", {
      isValid: null
    });
    if (!this.m_iframe) {
      this.preloadSdk();
    }
  },
  methods: {
    async initValidacion() {
      this.$store.dispatch("DO_CLICK_CTA", "comenzar veridas");
      this.$store.dispatch("DO_VERIDAS_EVENT", { type: "comienzo-flujo" });

      this.$store.dispatch("DO_IS_LOADING", true);
      this.$store.commit("ON_ERROR", "");
      this.$store.commit("ON_ERROR_VERIDAS", "");

      // Primero validamos si tiene permitido iniciar la biometria por intentos
      const puedeContinuar = await this.$store.dispatch("GET_REINTENTOS_BIO");
      if (!puedeContinuar) {
        this.$store.commit("ON_ERROR", "ERROR: reintentos-biometria");
        this.$store.dispatch("DO_IS_LOADING", false);
        return;
      }

      try {
        await this.$store.dispatch("GET_VERIDAS_IFRAME");

        // Verificamos si hubo algún error después del dispatch
        const error = this.$store.getters.getError();
        if (error) {
          Vue.$log.error("getVeridasIframe falló. Error:", error);
          this.$store.dispatch("DO_IS_LOADING", false);
          return;
        }
      } catch (error) {
        console.error("Error al obtener iframe de Veridas:", error);
        this.$store.dispatch("DO_IS_LOADING", false);
        return;
      }

      // Valido primero si tengo los permisos
      if (
        "mediaDevices" in navigator &&
        "getUserMedia" in navigator.mediaDevices
      ) {
        const permission = navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" }
        });

        permission.then(stream => {
          // Permisos de cámara otorgados
          stream.getTracks().forEach(track => track.stop());
          this.model.isDigital = true;
          this.model.isPresencial = false;
          this.model.isPresencialVoluntario = false;
          this.$store.dispatch("DO_DIGITAL", this.model);
          this.preloadSdk();
          setTimeout(() => {
            // Diferimos el inicio un poco para dar tiempo al stream de la camara
            // a cerrarse antes de iniciarlo de nuevo
            this.showVeridasSdk();
          }, 1000);
        });

        permission.catch(() => {
          // El usuario no dio los permisos necesarios
          this.$store.dispatch("DO_MENSAJE", ERROR_HABILITA_PERMISOS);
          this.$router.push({
            name: "mensajeVeridas",
            params: { mje: "error-habilita-permisos" }
          });
          return this.destroySdk();
        });
      } else {
        // No tengo cámara en el dispositivo
        this.$router.push({
          name: "mensajeVeridas",
          params: { mje: "error-habilita-permisos" }
        });
        return this.destroySdk();
      }
    },
    atras() {
      this.$router.push(
        this.config.pasos[this.config.pasos.identidad.pasoAnterior].path
      );
    }
  }
};
</script>

<style scoped>
p#titulo {
  font-size: 26px;
  font-weight: bold;
  margin: 16px 0;
  margin-top: 8px;
}

p#subtitulo {
  font-size: 16px;
  margin-bottom: 24px;
  font-weight: bold;
}

.cobranding-logo-header {
  top: 36px;
}

.anterior-link {
  cursor: pointer;
  font-size: 15px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-weight: bold;
  color: #237aba;
  padding: 8px 0 8px 40px;
  margin-top: 32px;
  margin-bottom: 30px;
  border: none;
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-image: url("../assets/img/1x/Arrow-Left.png");
  background-position: 0 8px;
}

.anterior-link:focus {
  outline: 0;
}

@media screen and (max-width: 600px) {
  #titulo {
    font-size: 26px;
    margin-bottom: 10px;
  }
}
</style>
